import React from 'react'
import { connect } from '@soltalabs/stateless'
import { siteList$, isFetchingSites$ } from 'modules/ravensdown/site'
import { isEmpty } from '@soltalabs/ramda-extra'
import { SiteCard } from 'components/ravensdown/common/SiteCard'

import { styled, s } from 'lib/styled'
import { EmptyListPrompt, StyledCircularProgress } from 'components/common/styles'

const Root = styled.div(s('flex-1'), {
  overflow: 'hidden',
})

const Scroll = styled.div`
  height: 100%;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`

const List = styled.ul`
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  scrollbar-width: none;
`

const Connected = connect(() => ({
  siteList: siteList$,
  isFetchingSites: isFetchingSites$,
}))(SiteList)

function SiteList({ siteList, isFetchingSites }) {
  return (
    <Root>
      <Scroll>
        <List className="container-job-list">
          {isFetchingSites ? (
            <StyledCircularProgress />
          ) : (
            siteList.map((site) => {
              const { siteName, assessments } = site

              return <SiteCard name={siteName} assessments={assessments} />
            })
          )}

          {isEmpty(siteList) && !isFetchingSites && (
            <EmptyListPrompt>No sites available</EmptyListPrompt>
          )}
        </List>
      </Scroll>
    </Root>
  )
}

export { Connected as SiteList }
